export const logger = (action, pathname, params, state, message) => {
  if (
    process.env &&
    process.env.NODE_ENV === 'development' &&
    process.env.REACT_APP_GRID_LOGGER === 'true'
  ) {
    console.groupCollapsed(`${action} - ${pathname}`);
    message && console.log(message);
    params && console.log('params', params);
    console.log('state', state);
    console.groupEnd();
  }
};

export const updateHistory = (
  history,
  params,
  replace = false,
  pathname = null
) => {
  logger(
    `LOCATION STATE ${replace ? `REPLACE` : `PUSH`}`,
    pathname || history.location.pathname,
    params,
    history.location.state
  );
  if (replace) {
    history.replace(pathname || history.location.pathname, {
      gridParams: params,
    });
  } else {
    history.push(pathname || history.location.pathname, {
      gridParams: params,
    });
  }
};

export const historySetGridInitialParams = (
  history,
  pathname,
  params,
  replace = false
) => {
  logger(
    `${replace ? `REPLACE` : `PUSH`} INITIAL PARAMS`,
    pathname,
    params,
    history.location.state
  );
  if (replace) {
    history.replace(pathname, {
      initialParams: params,
    });
  } else {
    history.push(pathname, {
      initialParams: params,
    });
  }
};
